import { v4 as uuidv4 } from 'uuid';

/**
 * Generate a UUID v4 string
 * @returns {string}
 */
// eslint-disable-next-line import/prefer-default-export
export const createUuid = () => uuidv4();
